// --- React
import React from "react";
// --- Styles
import "./styles.scss";

/**
 * DetailRow Component
 *
 * Displays a label-value pair in a horizontal row format.
 * Used in view drawers to show entity details.
 *
 * @component
 * @param {Object} props - Component properties
 * @param {string} props.label - The label text
 * @param {React.ReactNode} props.value - The value to display (shows "—" if null/undefined)
 * @param {boolean} [props.noBorder=false] - Whether to hide the bottom border
 * @returns {JSX.Element}
 *
 * @example
 * <DetailRow label="Status" value={data.status} />
 * <DetailRow label="Created" value={data.createdAt} noBorder />
 */
export const DetailRow = ({ label, value, noBorder = false }) => (
  <div className={`detail-row${noBorder ? " no-border" : ""}`}>
    <span className="detail-row-label">{label}</span>
    <span className="detail-row-value">{value ?? "—"}</span>
  </div>
);

export default DetailRow;
